(function() {
  "use strict";

  angular
    .module("app")
    .factory("DomainSelectorService", ["$http", "$q", DomainSelectorService]);

  function DomainSelectorService($http, $q) {
    var service = {
      getDomainById: getDomainById,
    };

    function getDomainById(domain, includeOtherIndicators) {
      var deferred = $q.defer();

      $http({
        method: "GET",
        url:
          "/api/RiskRankingData/GetDomainById?id=" +
          domain.id +
          "&includeOtherIndicators=" +
          (includeOtherIndicators ? "true" : "false"),
        cache: true, // this data rarely updates, no need for an instant re-request
      })
        .success(function(data) {
          processDomainData(data);
        })
        .error(function(error) {
          deferred.reject();
        });

      var processDomainData = function(data) {
        if (domain.defaultAsset) {
          data.defaultAsset = domain.defaultAsset[0];
        }

        deferred.resolve({
          data: data,
        });
      };

      return deferred.promise;
    }

    return service;
  }
})();
